import ENTITY_DATA from "../../../../data/index.js";
import { rootDoc } from "../../../../helpers/dom-selectors.js";
import makeAddBtn from "../../../global-components/forms/add-btn.js";
import makeHeader from "../../../global-components/header.js";
import makeReOrderBtn from "../../../global-components/re-order-btn.js";
import SettingsBtn from "../../../global-components/settings-btn.js";
import APP_COMPONENTS from "../components/index.js";
import APP_VIEWS from "./event-router.js";
import APP_EVENTS from "./events.js";
export default function App({ settingsBtn, settingsOverlay, header, logo, addBtn, reOrderBtn }) {
    _initAppShell();
    return Object.freeze({
        resize,
        executeEvent,
        executeEventWithData,
        executeFormEventWithData,
        executeFileEventWithData
    });
    function _initAppShell() {
        ENTITY_DATA.init();
        SettingsBtn({ settingsBtn, settingsOverlay }).init();
        makeHeader({ header, logo }).init();
        makeAddBtn({
            addBtn,
            events: APP_EVENTS,
            action: 'add-event-clicked'
        }).init();
        makeReOrderBtn({
            btn: reOrderBtn,
            events: APP_EVENTS,
            action: 'reorder-btn-clicked'
        }).init();
        APP_COMPONENTS.reOrderModal.init();
        APP_COMPONENTS.eventForms.init();
        APP_COMPONENTS.fileForms.init();
        APP_COMPONENTS.progressComponents.init();
    }
    function resize() {
        const vh = window.innerHeight / 100;
        rootDoc.style.setProperty("--vh", vh + "px");
    }
    async function executeEvent(action) {
        const view = APP_VIEWS.get(action);
        await view.execute();
    }
    async function executeEventWithData(detail) {
        const view = APP_VIEWS.getWithData(detail.action);
        await view.execute(detail.data);
    }
    async function executeFormEventWithData(detail) {
        const view = APP_VIEWS.getFormActionWithData(detail.action);
        await view.execute(detail.data);
    }
    async function executeFileEventWithData(detail) {
        const view = APP_VIEWS.getFileActionWithData(detail.action);
        await view.execute(detail.data);
    }
}
;
